export const SizeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0714 4.56202L11.7714 1.26202C11.511 1.00177 11.089 1.00177 10.8287 1.26202L0.928711 11.162C0.668457 11.4224 0.668457 11.8444 0.928711 12.1047L4.22871 15.4047C4.48904 15.6649 4.91104 15.6649 5.17138 15.4047L15.0714 5.50469C15.3316 5.24436 15.3316 4.82236 15.0714 4.56202ZM2.34346 11.6334L4.22879 9.74735L5.17146 10.6914L6.11479 9.74802L5.17146 8.80535L6.58612 7.39135L8.00012 8.80535L8.94279 7.86135L7.52879 6.44802L8.94279 5.03335L9.88546 5.97602L10.8288 5.03335L9.88546 4.09069L11.3001 2.67669L13.6568 5.03335L4.70012 13.99L2.34346 11.6334Z"
        fill="#3643BA"
      />
    </svg>
  )
}
